import React, { useEffect, useState } from 'react';
import { connect, history } from 'umi';

import { get } from 'lodash';
import moment from 'moment';
import cl from 'classnames';
import { List, Avatar } from 'antd';
// import { RightOutlined } from '@ant-design/icons';
import useReponsive from '@/hooks/useResponsive';
import useGCPI18n from '@/hooks/useGCPI18n';
import { BaseSpin } from '@/components';
import { getDeviceType } from '@/utils/utilsPoint';
import Header from '../../Header';
import styles from './index.less';

import rightImg from '@/assets/images/point/icon-right.png';

const AllCategories = props => {
  // 响应式 hook
  useReponsive();
  const GCPI18n = useGCPI18n();
  const { getConfigParamDXP, getCatgctList, loading = false } = props;
  // const catgctList = get(props, 'location.state.catgctList');
  const [catgctList, setcatgctList] = useState([]);
  const [date, setDate] = useState(0);

  useEffect(() => {
    getCatgctList().then(catgctListres => {
      if (get(catgctListres, 'code') === '200' && get(catgctListres, 'data.prodCatgList')) {
        const prodCatgList = get(catgctListres, 'data.prodCatgList');
        setcatgctList(prodCatgList);
      }
    });
    getConfigParamDXP({ paramCodeList: ['lms.point.rewards.new.duration'] }).then(res => {
      setDate(res.paramValue);
    });
  }, []);

  // 判断是否为新菜单
  const isNewMenu = createDate => {
    const today = moment();
    const creationTime = moment(createDate);
    const dataCha = today.diff(creationTime, 'days', true);
    return dataCha <= date;
  };

  const onOpenShopList = catgct => {
    history.push({
      pathname: `/pointshop/shoplist/${catgct.id}`,
      // state: { catgct },
    });
  };

  const titleDom = item => (
    <div>
      <span>{get(item, 'name') || '----'}</span>
      {get(item, 'createDate') && isNewMenu(get(item, 'createDate')) && (
        <span className={styles.new}>
          {GCPI18n({
            id: 'lb_dito_rewards_new_category',
          })}
        </span>
      )}
    </div>
  );

  return (
    <div
      className={cl(styles.AllCategoriesHeader, {
        [styles.androidAllCategoriesHeader]: getDeviceType() === 'android',
      })}
    >
      <Header
        title={GCPI18n({
          id: 'lb_header_all_categories',
        })}
      />
      <div className={styles.AllCategories}>
        <BaseSpin spinning={loading}>
          <List
            split={false}
            itemLayout="horizontal"
            dataSource={catgctList}
            renderItem={item => (
              <List.Item
                onClick={() => {
                  onOpenShopList(item);
                }}
                extra={<img src={rightImg} alt="" />}
              >
                <List.Item.Meta
                  avatar={<Avatar src={get(item, 'thumbImageUrl')} />}
                  title={titleDom(item)}
                  description={get(item, 'brief') || '---'}
                />
              </List.Item>
            )}
          />
        </BaseSpin>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getConfigParamDXP: payload =>
    dispatch({
      type: 'index/getConfigParamDXP',
      payload,
    }),
  getCatgctList: payload =>
    dispatch({
      type: 'pointShop/getCatgctList',
      payload,
    }),
});

export default connect(
  ({ loading }) => ({
    loading: loading.effects['pointShop/getCatgctList'],
  }),
  mapDispatchToProps,
)(AllCategories);
// export default connect(() => ({}), mapDispatchToProps)(AllCategories);
